/// <reference types="gapi" />

const loadGooglePickerApi = (): Promise<void> => {
  return new Promise(resolve => {
    window.gapi.load('picker', async (): Promise<void> => {
      resolve();
    });
  });
};

export default loadGooglePickerApi;
